import styled from '@emotion/styled'

type OperationType = 'progress' | 'negative' | 'neutral' | 'cancel'

export type FilterButtonProps = {
  children: any
  onClick: (e: any) => void
  operationType: OperationType
  width?: string
}

type CoreButtonProps = {
  isDisabled?: boolean
  operationType: OperationType
  width?: string
}

const Button = styled.button<CoreButtonProps>`
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid var(--White96);
  cursor: pointer;
  background: var(--White);
  color: var(--Red-Dark);
  &:hover {
    color: var(--Graphite);
    border: 1px Solid var(--White90);
    background: var(--White98);
  }
`

export const FilterButton = ({ operationType, ...props }: FilterButtonProps) => (
  <Button {...props} operationType={operationType} />
)
